import React, { useContext } from 'react';
import { Card, CardContent, CardHeader, IconButton, Tooltip, Box, Typography } from '@material-ui/core';
import { Panel } from '../../../../../Components/Panel/Panel';
import { useIntl } from 'react-intl';
import { Form, HtmlView } from '../../../../../Components';
import { useFormField } from '../../../../../Components/Form/FormField';
import { Edit } from '@material-ui/icons';
import { useAptorApi } from '../../../../../Api';
import { Module, UserContext } from '../../../../../Context/UserContext/UserContext';
import { EvaluationInfoEnum } from '../../../../../Context/EvaluationInfoEmun';

const UpdateConnectionInfo = ({ updateConnectionInfo, currentStepName, onUpdate }: any) => {
    const { formatMessage } = useIntl();
    const [editMode, setEditMode] = React.useState(false);
    const { api } = useAptorApi();
    const { locale, hasAccessToModule } = useContext(UserContext);
    const [submitting, setSubmitting] = React.useState(false);

    const handleSubmit = async (formData: any) => {
        setSubmitting(true);
        try {
            const payload = {
                type: EvaluationInfoEnum.updateConnectionInfo,
                data: {
                    ...updateConnectionInfo,
                    [currentStepName]: {
                        updateConnectionInfoSv: formData.updateConnectionInfoSv || '',
                        updateConnectionInfoEn: formData.updateConnectionInfoEn || '',
                    }
                },
            };

            await api.updateLawportalevaluationStepSettings(payload);

            if (onUpdate) {
                onUpdate();
            }

            setEditMode(false);
        } catch (error) {
            console.error('Error updating evaluation step settings:', error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Panel
            title={formatMessage({ id: 'law-portal.our-Law.update-connection-legal-list.header' })}
            style={{ width: '100%', boxSizing: 'border-box', backgroundColor: "#f7f0f1" }}
            rightComponent={
                !editMode && hasAccessToModule(Module.Administration) && (
                    <Tooltip title={formatMessage({ id: 'utils.icon.edit', defaultMessage: 'Edit' })}>
                        <IconButton
                            aria-label={formatMessage({ id: 'utils.icon.edit', defaultMessage: 'Edit' })}
                            onClick={() => setEditMode(true)}
                        >
                            <Edit fontSize="small" />
                        </IconButton>
                    </Tooltip>
                )
            }
        >
            {editMode ? (
                <EvaluationForm
                    editingData={updateConnectionInfo?.[currentStepName]}
                    submit={handleSubmit}
                    cancelEdit={() => { setEditMode(false) }}
                    submitting={submitting}
                />
            ) : (
                <Typography variant="body1">
                    <HtmlView value={
                        locale === 'en'
                            ? updateConnectionInfo?.[currentStepName]?.updateConnectionInfoEn
                            : updateConnectionInfo?.[currentStepName]?.updateConnectionInfoSv
                    } />
                </Typography>
            )}
        </Panel>
    );
};

const EvaluationForm = ({
    editingData,
    submit,
    cancelEdit,
    submitting,
}: {
    editingData: any;
    submit: any;
    cancelEdit: () => void;
    submitting?: boolean;
}) => {
    const { formatMessage } = useIntl();

    const chapterSv = useFormField({
        label: formatMessage({
            id: 'admin.law-portal.informationBoard.form.message.label.sv',
            defaultMessage: 'Message (Swedish)',
        }),
        name: 'updateConnectionInfoSv',
        type: 'rich-text',
        required: false,
        richTextEditorHeight: 'small',
        initialState: editingData?.updateConnectionInfoSv
            ? { value: editingData.updateConnectionInfoSv, label: editingData.updateConnectionInfoSv, isValid: true }
            : undefined,
    });

    const chapterEn = useFormField({
        label: formatMessage({
            id: 'admin.law-portal.informationBoard.form.message.label.en',
            defaultMessage: 'Message (English)',
        }),
        name: 'updateConnectionInfoEn',
        type: 'rich-text',
        required: false,
        richTextEditorHeight: 'small',
        initialState: editingData?.updateConnectionInfoEn
            ? { value: editingData.updateConnectionInfoEn, label: editingData.updateConnectionInfoEn, isValid: true }
            : undefined,
    });

    return (
        <Form
            submit={submit}
            cancel={cancelEdit}
            groups={[{ grid: { type: 'column', items: [chapterSv, chapterEn] } }]}
        />
    );
};

export default UpdateConnectionInfo;
